// Inline SVG brand wordmarks — keeps bundle small. Greyscale styled by parent.
export const HubspotMark = (props) => (
    <svg viewBox="0 0 32 32" fill="none" {...props}>
        <path d="M22.6 13.1V9.6a2.7 2.7 0 0 0 1.6-2.5 2.7 2.7 0 1 0-5.4 0 2.7 2.7 0 0 0 1.6 2.5v3.5a7.6 7.6 0 0 0-3.6 1.6L7.2 7.7c.07-.27.11-.55.11-.84a3.4 3.4 0 1 0-3.4 3.4c.6 0 1.16-.16 1.65-.43l9.4 7.32a7.6 7.6 0 0 0-1.16 4.05c0 1.5.43 2.9 1.18 4.07l-2.86 2.86a2.4 2.4 0 0 0-.71-.11 2.5 2.5 0 1 0 2.5 2.5c0-.25-.04-.49-.11-.71l2.83-2.83a7.6 7.6 0 1 0 5.86-13.27Zm-1.1 11.4a3.9 3.9 0 1 1 0-7.8 3.9 3.9 0 0 1 0 7.8Z" fill="currentColor"/>
    </svg>
);

export const PipedriveMark = (props) => (
    <svg viewBox="0 0 32 32" fill="none" {...props}>
        <path d="M16.4 6.5c-3.4 0-6 1.7-7.4 3.7l-.2-3.2H4.1l.1 3.7v18.6h5V22a7 7 0 0 0 6 2.6c4.7 0 8.7-3.6 8.7-9.1 0-5.5-3.7-9-7.5-9Zm-1.6 14.2c-2.7 0-4.5-2.1-4.5-5.1 0-3 1.7-5.1 4.5-5.1 2.7 0 4.4 2.2 4.4 5.1s-1.7 5.1-4.4 5.1Z" fill="currentColor"/>
    </svg>
);

export const ZohoMark = (props) => (
    <svg viewBox="0 0 32 32" fill="none" {...props}>
        <path d="M5 9h14L9 21h14v3H5l10-12H5V9Z" fill="currentColor"/>
        <circle cx="25" cy="11" r="3" fill="currentColor" opacity="0.6"/>
    </svg>
);

export const ZoomMark = (props) => (
    <svg viewBox="0 0 32 32" fill="none" {...props}>
        <rect x="3" y="9" width="18" height="14" rx="3" fill="currentColor"/>
        <path d="M22 13l7-3v12l-7-3v-6Z" fill="currentColor"/>
    </svg>
);

export const TeamsMark = (props) => (
    <svg viewBox="0 0 32 32" fill="none" {...props}>
        <rect x="3" y="6" width="14" height="20" rx="2" fill="currentColor"/>
        <text x="10" y="20" textAnchor="middle" fill="white" fontSize="11" fontWeight="700" fontFamily="system-ui">T</text>
        <circle cx="23" cy="12" r="3" fill="currentColor" opacity="0.7"/>
        <path d="M19 17h8v8a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-8Z" fill="currentColor" opacity="0.5"/>
    </svg>
);

export const MeetMark = (props) => (
    <svg viewBox="0 0 32 32" fill="none" {...props}>
        <path d="M3 9h12v14H3z" fill="currentColor" opacity="0.6"/>
        <path d="M15 12l8-4v16l-8-4v-8Z" fill="currentColor"/>
        <path d="M23 14h6v4h-6z" fill="currentColor" opacity="0.4"/>
    </svg>
);

const logos = [
    { name: "HubSpot", Mark: HubspotMark },
    { name: "Pipedrive", Mark: PipedriveMark },
    { name: "Zoho CRM", Mark: ZohoMark },
    { name: "Zoom", Mark: ZoomMark },
    { name: "Microsoft Teams", Mark: TeamsMark },
    { name: "Google Meet", Mark: MeetMark },
];

export default function BrandLogos({ tone = "light" }) {
    const isDark = tone === "dark";
    return (
        <div data-testid="brand-logos" className={`flex flex-wrap items-center justify-center gap-x-12 gap-y-6 ${isDark ? "text-zinc-500" : "text-zinc-400"}`}>
            {logos.map(({ name, Mark }) => (
                <div key={name} className="flex items-center gap-2 grayscale opacity-80 hover:opacity-100 transition-opacity">
                    <Mark className="h-7 w-7" />
                    <span className={`font-display text-base font-semibold tracking-tight ${isDark ? "text-zinc-400" : "text-zinc-500"}`}>{name}</span>
                </div>
            ))}
        </div>
    );
}
